import { BufferGeometry, Float32BufferAttribute } from 'three';

/** 四角形（2三角形）を追加 — 頂点は反時計回り = 表面 */
export function quad(
  verts: number[], normals: number[],
  ax: number, ay: number, az: number,
  bx: number, by: number, bz: number,
  cx: number, cy: number, cz: number,
  dx: number, dy: number, dz: number,
): void {
  const ux = bx - ax, uy = by - ay, uz = bz - az;
  const vx = dx - ax, vy = dy - ay, vz = dz - az;
  let nx = uy * vz - uz * vy;
  let ny = uz * vx - ux * vz;
  let nz = ux * vy - uy * vx;
  const len = Math.sqrt(nx * nx + ny * ny + nz * nz) || 1;
  nx /= len; ny /= len; nz /= len;

  verts.push(ax, ay, az, bx, by, bz, cx, cy, cz);
  verts.push(ax, ay, az, cx, cy, cz, dx, dy, dz);
  for (let i = 0; i < 6; i++) normals.push(nx, ny, nz);
}

/** 三角形を追加 */
export function tri(
  verts: number[], normals: number[],
  ax: number, ay: number, az: number,
  bx: number, by: number, bz: number,
  cx: number, cy: number, cz: number,
): void {
  const ux = bx - ax, uy = by - ay, uz = bz - az;
  const vx = cx - ax, vy = cy - ay, vz = cz - az;
  let nx = uy * vz - uz * vy;
  let ny = uz * vx - ux * vz;
  let nz = ux * vy - uy * vx;
  const len = Math.sqrt(nx * nx + ny * ny + nz * nz) || 1;
  nx /= len; ny /= len; nz /= len;
  verts.push(ax, ay, az, bx, by, bz, cx, cy, cz);
  normals.push(nx, ny, nz, nx, ny, nz, nx, ny, nz);
}

/** 頂点・法線配列からBufferGeometryを生成 */
export function buildGeo(verts: number[], normals: number[]): BufferGeometry {
  const geo = new BufferGeometry();
  geo.setAttribute('position', new Float32BufferAttribute(verts, 3));
  geo.setAttribute('normal', new Float32BufferAttribute(normals, 3));
  return geo;
}
